export default __webpack_public_path__ + "static/media/s.11745788.svg";